import { Box, Skeleton } from "@mui/material";

export default function AttendanceSkeleton() {
    return (
        <Box
            sx={{
                bgcolor: "var(--primary-color)",
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            {/* Header Skeleton */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 448,
                }}
            >
                <Skeleton
                    variant="rounded"
                    sx={{ bgcolor: "var(--gradient-overlay-bg-color)", borderRadius: 2 }}
                    width="100%"
                    height={40}
                />
            </Box>

            {/* Center Content Skeleton */}
            <Box
                sx={{
                    flex: 1,
                    width: "100%",
                    maxWidth: 448,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 3,
                    padding: '0.5rem'
                }}
            >
                <Skeleton
                    variant="rectangular"
                    sx={{ bgcolor: "var(--gradient-overlay-bg-color)", borderRadius: 2 }}
                    width="100%"
                    height={200}
                />
                <Skeleton
                    variant="rectangular"
                    sx={{ bgcolor: "var(--gradient-overlay-bg-color)", borderRadius: 2 }}
                    width="100%"
                    height={200}
                />
                <Skeleton
                    variant="rectangular"
                    sx={{ bgcolor: "var(--gradient-overlay-bg-color)", borderRadius: 2 }}
                    width="100%"
                    height={200}
                />
            </Box>

            {/* Footer Skeleton */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 448,
                }}
            >
                <Skeleton
                    variant="rounded"
                    sx={{ bgcolor: "var(--gradient-overlay-bg-color)", borderRadius: 2 }}
                    width="100%"
                    height={50}
                />
            </Box>
        </Box>
    )
}